import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Lista płatności',
  type: 'object',
  properties: {
    filters: {
      type: 'object',
      properties: {
        year: {
          title: 'Rok',
          type: 'number',
          fieldRequired: true
        },

        month: {
          title: 'Miesiąc',
          type: 'number',
          fieldRequired: true
        },

        selectedSchool: {
          title: 'Szkoła',
          type: 'string',
          fieldRequired: false
        },

        selectedType: {
          title: 'Rodzaj listy',
          type: 'number',
          fieldRequired: false
        }
      }
    },

    split: {
      type: 'object',
      properties: {
        grant: {
          title: 'Dotacja (%)',
          type: 'number',
          fieldRequired: true
        },

        contribution: {
          title: 'Wkład własny (%)',
          type: 'number',
          fieldRequired: true
        }
      }
    },

    submit: {
      type: 'object',
      properties: {
        paymentDate: {
          format: 'date',
          fieldRequired: true,
          title: 'Termin płatności',
          type: 'string'
        },

        packId: {
          type: 'number',
          title: 'Wybierz paczkę płatności'
        }
      }
    }
  },
  allOf: [validationMessages]
};
